var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contents-inner" },
    [
      _c("p", {
        staticClass: "text-block fwB pega-pre-wrap",
        attrs: { "data-test": "catchCopy" },
        domProps: { textContent: _vm._s(_vm.description.catchCopy) },
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "text-block pega-pre-wrap",
        attrs: { "data-test": "detail" },
        domProps: { textContent: _vm._s(_vm.description.detail) },
      }),
      _vm._v(" "),
      _vm.description.workflow
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("p", {
              staticClass: "mt20 pega-pre-wrap",
              attrs: { "data-test": "workflow-value" },
              domProps: { textContent: _vm._s(_vm.description.workflow) },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.attentions
        ? _c(
            "h3",
            {
              staticClass: "hd-type-0n3",
              attrs: { "data-test": "attention-title" },
            },
            [_c("span", [_vm._v("仕事の魅力")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "point-contents" },
        [
          _vm._l(_vm.attentionsNotEmpty, function (attention, key) {
            return [
              _c("div", { key: key + "-title", staticClass: "mt20 mb20" }, [
                _vm._m(1, true),
                _vm._v(" "),
                _c(
                  "strong",
                  {
                    staticClass: "pl10",
                    attrs: { "data-test": key + "-title" },
                  },
                  [_vm._v(_vm._s(attention.title))]
                ),
              ]),
              _vm._v(" "),
              _c("p", {
                key: key + "-text",
                staticClass: "pega-pre-wrap",
                attrs: { "data-test": key + "-text" },
                domProps: { textContent: _vm._s(attention.text) },
              }),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.isShow.improved
        ? [
            _vm._m(2),
            _vm._v(" "),
            _c("p", {
              staticClass: "mt20 pega-pre-wrap",
              attrs: { "data-test": "improved-value" },
              domProps: { textContent: _vm._s(_vm.description.improved) },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.strengths
        ? _c(
            "h3",
            {
              staticClass: "hd-type-0n3",
              attrs: { "data-test": "strengths-title" },
            },
            [_c("span", [_vm._v("アピールポイント")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt15" },
        [
          _vm._l(_vm.strengthsNotEmpty, function (value, key) {
            return [
              _c(
                "span",
                {
                  key: key + "-title",
                  staticClass: "apoint",
                  attrs: { "data-test": key + "-title" },
                },
                [_vm._v(_vm._s(_vm.strengthTitle[key]))]
              ),
              _vm._v(" "),
              _c("p", {
                key: key + "-value",
                staticClass: "mt15 mb15 pega-pre-wrap",
                attrs: { "data-test": key + "-value" },
                domProps: { textContent: _vm._s(value) },
              }),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "workflow-title" } },
      [_c("span", [_vm._v("一日の仕事の流れ")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "point fs10" }, [
      _vm._v("POINT"),
      _c("span", { staticClass: "fs16" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h3",
      { staticClass: "hd-type-0n3", attrs: { "data-test": "improved-title" } },
      [_c("span", [_vm._v("この仕事で磨ける経験・能力")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }